import React, { useState } from 'react';
import MultiStepCreateForm from './MultiStepCreateForm';
import CreateFormLanding from './CreateFormLanding';
import CreateCaseForm from './CreateCaseForm';

function QuickCreateForm() {
    const [renderSubFormFields, setRenderSubFormFields] = useState([]);
    const [showMoreForm, setShowMoreForm] = useState(false);
   
  return (
    <>
        {showMoreForm ?
            <div className='flex lg:col-span-4 mt-10 col-span-6 lg:col-start-2 w-full flex-col'>
            <MultiStepCreateForm renderSubFormFields={renderSubFormFields} setShowMoreForm={setShowMoreForm}/>
            </div>
            :
            // <div className='col-span-6 w-full flex-col'>
            // <CreateCaseForm />
            // </div>
            <CreateFormLanding setRenderSubFormFields= {setRenderSubFormFields} setShowMoreForm={setShowMoreForm} />
        }
    </>
    
  )
}

export default QuickCreateForm